export default __webpack_public_path__ + "static/media/chevron_big_right.ceabecc7.svg";